// extracted by mini-css-extract-plugin
var _1 = "useAICompose-module__animateUploadProgressBarWidth--S2qzL";
var _2 = "useAICompose-module__animatedBackground--C8usn";
var _3 = "data-ai-compose";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "placeholderAttribute" }
